/**
 * The list-verdict step: "the list is terrible". Violet, like List groups.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Rows3 } from 'lucide-react';

import { StepCard, Switch } from '@/components/ui';

import type { DraftVerdict, DropGenPlanDetail } from '../../../../drop-generator.types';
import { InheritedSection } from '../../master/InheritedSection';
import { useSectionSources } from '../../master/section-sources';
import type { ContainerEditor } from '../../state/useContainerEditor';
import { failModeWord } from '../fail-consequence/fail-words';
import { ListVerdictStep } from '../ListVerdictStep';

export function listVerdictSummary(verdict: DraftVerdict, failMode: string): string {
  if (!verdict.enabled) return 'off — the list keeps its day';
  if (verdict.advanced) return 'nested rule (set through the API)';
  const n = verdict.rows.length;
  // 23/10/2026 — "A list fails" is the FAIL's own row: its choice joins the summary.
  return `${n} condition${n === 1 ? '' : 's'} · a FAIL burns the list · ${failModeWord(failMode)}`;
}

interface Props {
  index: number;
  editor: ContainerEditor;
  plan: DropGenPlanDetail;
  containerId: string | null;
}

export const ListVerdictCard: FC<Props> = ({ index, editor, plan, containerId }) => {
  const { verdict } = editor.draft;
  const own = useSectionSources().isOwn('verdict');
  return (
    <StepCard
      index={index}
      tone="violet"
      icon={Rows3}
      title="List verdict"
      summary={listVerdictSummary(verdict, editor.draft.failMode)}
      headerRight={
        <Switch
          checked={verdict.enabled}
          disabled={!own}
          onCheckedChange={(enabled) => editor.verdictPatch({ enabled })}
          aria-label="Enable the list verdict"
        />
      }
    >
      <InheritedSection section="verdict">
        <ListVerdictStep editor={editor} plan={plan} containerId={containerId} />
      </InheritedSection>
    </StepCard>
  );
};
